import { gql } from '@apollo/client'
import React from 'react'

import { checklistsClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useChecklistState = () => React.useContext(Context)
export const useChecklist = () => useChecklistState()?.checklist

const QUERY = gql`
  query Checklist($id: ID) {
    checklist(id: $id, filter: { includeDisabled: true, includeDeleted: true, ignoreSegments: true }) {
      id
      questions {
        id
        name
        reference
        parentReference
        data
        description
        documents {
          id
          src
          type
          description
        }
        displayConditions
        ordination
        categoryOrdination
        required
        allowNull
        photosEnabled
        photosRequired
        notesEnabled
        notesRequired
        defaultValue
        options {
          id
          name
          reference
          ordination
        }
        masks {
          id
          name
          pattern
        }
        category {
          id
          name
        }
        type {
          id
          name
        }
      }
    }
  }
`

const ChecklistsLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: checklistsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ChecklistsLoader
